export const PAGINATION_XS = 5
export const PAGINATION_SM = 10
export const PAGINATION_MD = 15
export const PAGINATION_LG = 20
export const PAGINATION_XL = 25

export const PRODUCTION = "production"
export const STAGING = "staging"
export const DEVELOPMENT = "development"



// WEBPACK FOOTER //
// ./src/config/constant.js